import { motion } from "framer-motion";
import { LOGOS } from "@/lib/assets";
import { FileDown, Award } from "lucide-react";

export default function Instructor() {
  return (
    <section id="docente" className="py-24 md:py-40 bg-secondary text-secondary-foreground" data-testid="instructor-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-6"
        >
          <p className="text-primary uppercase tracking-[0.3em] text-xs font-semibold mb-6">Docente del corso</p>
          <h2 className="font-display font-black text-5xl md:text-7xl tracking-tighter leading-[0.85]">
            Ugo<br />Filosa
          </h2>
          <p className="font-serif-editorial italic text-2xl md:text-3xl mt-6 text-secondary-foreground/70">
            Fondatore di Offroad Italia
          </p>
          <p className="text-lg mt-8 max-w-xl leading-relaxed">
            Il corso sarà tenuto da <strong>Ugo Filosa</strong> di <strong>Offroad Italia</strong>, punto di riferimento per
            l'avventura in enduro e 4x4. Un percorso pratico per usare OsmAnd sul serio, sul campo.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <div className="flex items-start gap-4 border border-foreground/15 rounded-2xl p-6 bg-background/40 flex-1">
              <FileDown className="w-6 h-6 text-primary shrink-0 mt-1" strokeWidth={2} />
              <div>
                <h3 className="font-display font-bold text-lg">File di esercitazione</h3>
                <p className="text-sm text-secondary-foreground/70 mt-1">
                  Tutti gli iscritti riceveranno dei file per esercitarsi durante il corso online.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4 border border-foreground/15 rounded-2xl p-6 bg-background/40 flex-1">
              <Award className="w-6 h-6 text-primary shrink-0 mt-1" strokeWidth={2} />
              <div>
                <h3 className="font-display font-bold text-lg">100% Gratuito</h3>
                <p className="text-sm text-secondary-foreground/70 mt-1">
                  Corso online completamente gratuito, aperto a tutta la community offroad.
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-6"
        >
          <a href="https://www.offroaditalia.com" target="_blank" rel="noopener noreferrer" className="block rounded-[2rem] overflow-hidden border border-foreground/15 bg-white p-8 md:p-12 flex items-center justify-center transition-transform hover:scale-[1.02]" data-testid="offroad-logo-link">
            <img src={LOGOS.offroadVertical} alt="Offroad Italia" className="w-full max-w-sm h-auto" data-testid="offroad-logo-main" />
          </a>
          <a href="https://www.offroaditalia.com" target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary hover:underline" data-testid="instructor-website-link">
            Scopri di più su www.offroaditalia.com →
          </a>
          <div className="mt-6 rounded-2xl border border-foreground/15 bg-background/40 p-6 flex items-center justify-between gap-4">
            <span className="text-xs uppercase tracking-[0.2em] text-secondary-foreground/60 font-semibold">In collaborazione con</span>
            <img src={LOGOS.osmandBanner} alt="OsmAnd" className="h-10 w-auto rounded" data-testid="osmand-logo-collab" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
